<template>
    <main class="data-table">
        <v-data-table
            :headers="headers"
            :items="establishmentsList"
            :total-items="30"
            :hide-actions="true"
            :must-sort="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-establishments-table-item
                    :data-item="props.item"
                ></app-establishments-table-item>
            </template>
        </v-data-table>

        <infinite-loading @infinite="load" :identifier="infiniteId">
            <div slot="no-results"></div>
            <div slot="no-more"></div>
        </infinite-loading>
    </main>
</template>

<script>
import AppEstablishmentsTableItem from "./components/EstablishmentsTableItem";
import InfiniteLoading from "vue-infinite-loading";
import EventBus from "@packages/event-bus";
import provider from "@mixins/provider";
import { redirectUtils } from "../../../packages/util/redirect/redirectUtils";

export default {
    components: {
        AppEstablishmentsTableItem,
        InfiniteLoading,
    },
    beforeMount() {
        const url = this.isPartner ? redirectUtils.mountUrl('/new/parceiro/estabelecimentos') : redirectUtils.mountUrl('/new/admin/estabelecimentos');
        location.assign(url)
    },
    created() {
        EventBus.$on("LOAD_DATA", this.reload);
    },
    destroyed() {
        EventBus.$off("LOAD_DATA", this.reload);
    },
    data() {
        return {
            entity: "establishments",
            infiniteId: +new Date(),
            establishmentsList: [],
            page: 0,
            size: "",
            filter: "",
            order: "",
            desc: false,

            loadOnFilters: false,
        };
    },
    mixins: [provider],
    methods: {
        async load($state) {
            const retorno = await this.$api.establishments.list({
                page: this.page,
                size: this.size,
                filter: this.filter,
                order: this.order,
            });
            if (retorno.content.length !== 0) {
                this.establishmentsList.push(...retorno.content);
                $state.loaded();
                this.page++;
                if (retorno.content.length < 30) {
                    $state.complete();
                }
            } else {
                $state.complete();
            }
        },
        reload(search) {
            this.page = 0;
            this.establishmentsList = [];
            this.filter = search;
            this.infiniteId++;
        },
    },

    computed: {
        isPartner() {
            return this.$store.state.users.user.tipo === "PARCEIRO";
        },
        isAdmin() {
            return (
                this.$store.state.users.admin && !this.$store.state.users.user
            );
        },
        headers() {
            return window.location.pathname === "/admin/estabelecimentos"
                ? [
                      {
                          text: this.$t("message.admGenerics.message.active"),
                          value: "isActive",
                          width: "60px",
                      },
                      {
                          text: this.$t("message.admGenerics.message.id"),
                          value: "id",
                      },
                      {
                          text: this.$t("message.generics.message.name"),
                          value: "name",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.numberLocals"
                          ),
                          value: "localAccount",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.numberLicences"
                          ),
                          value: "accessPointCount",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.numberActiveCampaigns"
                          ),
                          value: "activeCampaignsCount",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.registration"
                          ),
                          value: "registrationDate",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.lastLogin"
                          ),
                          value: "lastLogin",
                      },
                      {
                          text: this.$t("message.admGenerics.message.edition"),
                          value: null,
                          sortable: false,
                      },
                  ]
                : [
                      {
                          text: this.$t("message.admGenerics.message.active"),
                          value: "isActive",
                          width: "60px",
                      },
                      {
                          text: this.$t("message.generics.message.name"),
                          value: "name",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.numberLocals"
                          ),
                          value: "localAccount",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.numberLicences"
                          ),
                          value: "accessPointCount",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.numberActiveCampaigns"
                          ),
                          value: "activeCampaignsCount",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.registration"
                          ),
                          value: "registrationDate",
                      },
                      {
                          text: this.$t(
                              "message.admGenerics.message.lastLogin"
                          ),
                          value: "lastLogin",
                      },
                      {
                          text: this.$t("message.admGenerics.message.edition"),
                          value: null,
                          sortable: false,
                      },
                  ];
        },
    },
};
</script>

<style scoped></style>
